// PageEditorToolbarSection.jsx

import React from 'react';

// CSS
import './PageEditorToolbarSection.css';

// Components
import Divider from 'components/divider/Divider';

/**
 * PageEditorToolbarSection
 *
 * Renders one labeled section inside the shared page editor toolbar.
 *
 * @param {ReactNode[]} actionNodes - Action buttons rendered in the section.
 * @param {ReactNode[][]} actionNodeRows - Optional supplemental action rows rendered below the main row.
 * @param {string} label - Uppercase section label.
 * @param {ReactNode[][]} pillNodeGroups - Optional pill groups rendered before icon buttons.
 *
 * @returns {ReactNode} The rendered toolbar section.
 */
const PageEditorToolbarSection = ({
    actionNodes = [],
    actionNodeRows = [],
    label = '',
    pillNodeGroups = [],
}) => {

    // ----- CONTEXT ----- //

    const resolvedActionNodes = Array.isArray(actionNodes) ? actionNodes.filter(Boolean) : [];
    const resolvedActionNodeRows = Array.isArray(actionNodeRows)
        ? actionNodeRows.filter((row) => Array.isArray(row) && row.some(Boolean))
        : [];
    const resolvedPillNodeGroups = Array.isArray(pillNodeGroups)
        ? pillNodeGroups.filter((group) => Array.isArray(group) && group.some(Boolean))
        : [];
    const showMainGroup = resolvedActionNodes.length > 0 || resolvedPillNodeGroups.length > 0;

    // ----- RENDER ----- //

    return (
        <div className="layout-editor-toolbar-section-container">

            {/* LABEL */}
            <div
              className="layout-editor-toolbar-section-label"
            >
                {label}
            </div>

            {/* LAYOUT EDITOR TOOLBAR SECTION GROUPS */}
            <div className="layout-editor-toolbar-section-groups">

                {showMainGroup ? (
                    <div className="layout-editor-toolbar-section-group">

                        {resolvedActionNodes}

                        {resolvedActionNodes.length > 0 && resolvedPillNodeGroups.length > 0 ? (
                            <Divider direction="vertical" />
                        ) : null}

                        {resolvedPillNodeGroups.map((group, groupIndex) => (
                            <div className="layout-editor-toolbar-section-pills" key={`${label || 'section'}:pills:${groupIndex}`}>
                                {group}
                            </div>
                        ))}

                    </div>
                ) : null}

                {resolvedActionNodeRows.map((row, rowIndex) => (
                    <div className="layout-editor-toolbar-section-group" key={`${label || 'section'}:row:${rowIndex}`}>
                        {row}
                    </div>
                ))}

            </div>
        </div>
    );
};

// Dev Tools
PageEditorToolbarSection.displayName = 'PageEditorToolbarSection';

export default PageEditorToolbarSection;
